<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="make-unavailable-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-error class="mx-auto mb-4"></animated-error>
            </div>
            <h4 class="text-center mb-4">Unfortunately, we are currently unable to provide repairs for that make.</h4>
        </div>
    </b-modal>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>